import { Routes } from '@angular/router';
import { ForumCategoriesComponent } from './forum-categories/forum-categories.component';
// import { ForumsComponent } from './forums/forums.component';

export const ForumRoutingModule: Routes = [
	{ path: 'forum-category', component: ForumCategoriesComponent },
	// { path: 'forum', component: ForumsComponent },
	// { path: 'forum/:id', component: ForumPostsComponent },
];
